import React, { useState, useEffect } from 'react';

import {

  Box,

  Typography,

  Paper,

  Tabs,

  Tab,

  Table,

  TableBody,

  TableCell,

  TableContainer,

  TableHead,

  TableRow,

  Button,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  TextField,

  Grid,

  IconButton,

  Chip,

  MenuItem,

  Alert,

  List,

  ListItem,

  ListItemText,

  ListItemSecondaryAction,

  Divider,

} from '@mui/material';

import {

  Add as AddIcon,

  Edit as EditIcon,

  Delete as DeleteIcon,

  Refresh as RefreshIcon,

  Save as SaveIcon,

  Backup as BackupIcon,

  Restore as RestoreIcon,

  Business as BusinessIcon,

  Person as PersonIcon,

} from '@mui/icons-material';

import Switch from '@mui/material/Switch';

import FormControlLabel from '@mui/material/FormControlLabel';

import api from '../../services/api';

import { toast } from 'react-toastify';



function TabPanel({ children, value, index }) {

  return (

    <div hidden={value !== index}>

      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}

    </div>

  );

}



export default function Configuracoes() {

  const [tab, setTab] = useState(0);



  // Estados para Usuários

  const [usuarios, setUsuarios] = useState([]);

  const [openUsuario, setOpenUsuario] = useState(false);

  const [editingUsuarioId, setEditingUsuarioId] = useState(null);

  const [usuarioFormData, setUsuarioFormData] = useState({

    nome: '',

    email: '',

    senha: '',

    nivel_acesso: 'operador',

  });



  // Estados para Dados da Empresa

  const [empresaData, setEmpresaData] = useState({

    razao_social: '',

    cnpj: '',

    endereco: '',

    cidade: '',

    estado: '',

    cep: '',

    telefone: '',

    email: '',

  });

  const [loadingEmpresa, setLoadingEmpresa] = useState(false);



  // Estados para Backup

  const [backups, setBackups] = useState([]);

  const [loadingBackup, setLoadingBackup] = useState(false);

  const [backupFrequencia, setBackupFrequencia] = useState('desativado');

  const [loadingAgendamento, setLoadingAgendamento] = useState(false);

  const [loginBackgroundUrl, setLoginBackgroundUrl] = useState('');

  const [uploadingBackground, setUploadingBackground] = useState(false);

  const [papelTimbradoUrl, setPapelTimbradoUrl] = useState('');

  const [uploadingTimbrado, setUploadingTimbrado] = useState(false);

  const [mapaDanosUrl, setMapaDanosUrl] = useState('');

  const [uploadingMapaDanos, setUploadingMapaDanos] = useState(false);

  // Estados para Outorgados
  const [outorgados, setOutorgados] = useState([]);
  const [openOutorgado, setOpenOutorgado] = useState(false);
  const [editingOutorgadoId, setEditingOutorgadoId] = useState(null);
  const [outorgadoForm, setOutorgadoForm] = useState({
    nome: '', cpf: '', rg: '', nacionalidade: 'BRASILEIRA',
    endereco: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '',
  });

  const cacheBust = (url) => (url ? `${url}?t=${Date.now()}` : '');



  useEffect(() => {

    if (tab === 0) {

      loadUsuarios();

    } else if (tab === 2) {

      loadDadosEmpresa();

    } else if (tab === 3) {

      loadLoginBackground();

      loadMapaDanos();

    } else if (tab === 4) {

      loadBackups();

      loadAgendamento();

    } else if (tab === 5) {

      loadPapelTimbrado();

    } else if (tab === 6) {
      loadOutorgados();
    }

  }, [tab]);



  // ==================== ABA USUÁRIOS ====================



  const loadUsuarios = async () => {

    try {

      const response = await api.get('/usuarios');

      setUsuarios(response.data || []);

    } catch (error) {

      console.error('Erro ao carregar usuários:', error);

      toast.error('Erro ao carregar usuários');

    }

  };



  const handleOpenUsuario = (usuario = null) => {

    if (usuario) {

      setEditingUsuarioId(usuario.id);

      setUsuarioFormData({

        nome: usuario.nome,

        email: usuario.email,

        senha: '',

        nivel_acesso: usuario.nivel_acesso,

      });

    } else {

      setEditingUsuarioId(null);

      setUsuarioFormData({

        nome: '',

        email: '',

        senha: '',

        nivel_acesso: 'operador',

      });

    }

    setOpenUsuario(true);

  };



  const handleCloseUsuario = () => {

    setOpenUsuario(false);

    setEditingUsuarioId(null);

  };



  const handleSubmitUsuario = async () => {

    try {

      // Validaões

      if (!usuarioFormData.nome) {

        toast.error('Nome completo é obrigatório');

        return;

      }



      if (!editingUsuarioId && !usuarioFormData.senha) {

        toast.error('Senha é obrigatória para novos usuários');

        return;

      }



      const dataToSend = { ...usuarioFormData };



      // Se não estiver editando e email estiver vazio, o backend gerará automaticamente

      if (!editingUsuarioId && !dataToSend.email) {

        delete dataToSend.email; // Deixar backend gerar nome.sobrenome

      }



      if (!dataToSend.senha) {

        delete dataToSend.senha; // Não enviar senha vazia na edição

      }



      if (editingUsuarioId) {

        await api.put(`/usuarios/${editingUsuarioId}`, dataToSend);

        toast.success('Usuário atualizado com sucesso!');

      } else {

        const response = await api.post('/usuarios', dataToSend);

        toast.success(`Usuário criado! Login: ${response.data.email}`);

      }



      handleCloseUsuario();

      loadUsuarios();

    } catch (error) {

      console.error('Erro ao salvar usuário:', error);

      toast.error(error.response.data.error || 'Erro ao salvar usuário');

    }

  };



  const handleToggleUsuarioAtivo = async (id, ativo) => {

    try {

      await api.put(`/usuarios/${id}`, { ativo: !ativo });

      toast.success(`Usuário ${!ativo ? 'ativado' : 'desativado'} com sucesso!`);

      loadUsuarios();

    } catch (error) {

      console.error('Erro ao alterar status do usuário:', error);

      toast.error('Erro ao alterar status do usuário');

    }

  };



  const getNivelAcessoLabel = (nivel) => {

    const niveis = {

      admin: 'Administrador',

      gerente: 'Gerente',

      vendedor: 'Vendedor',

      operador: 'Operador',

    };

    return niveis[nivel] || nivel;

  };



  const getNivelAcessoColor = (nivel) => {

    const cores = {

      admin: 'error',

      gerente: 'warning',

      vendedor: 'primary',

      operador: 'default',

    };

    return cores[nivel] || 'default';

  };



  // ==================== ABA DADOS DA EMPRESA ====================



  const loadDadosEmpresa = async () => {

    try {

      const response = await api.get('/configuracoes/empresa');

      if (response.data) {

        setEmpresaData(response.data);

      }

    } catch (error) {

      console.error('Erro ao carregar dados da empresa:', error);

      // Não mostrar erro se endpoint não existir ainda

    }

  };



  const handleSalvarEmpresa = async () => {

    if (loadingEmpresa) return;



    try {

      if (!empresaData.razao_social) {

        toast.error('Razão Social é obrigatória');

        return;

      }



      setLoadingEmpresa(true);

      await api.post('/configuracoes/empresa', empresaData);

      toast.success('Dados da empresa salvos com sucesso!');

      loadDadosEmpresa();

    } catch (error) {

      console.error('Erro ao salvar dados da empresa:', error);

      toast.error(error.response.data.error || 'Erro ao salvar dados da empresa');

    } finally {

      setLoadingEmpresa(false);

    }

  };



  // ==================== ABA APARÊNCIA ====================



  const loadLoginBackground = async () => {

    try {

      const response = await api.get('/branding/login-background');

      setLoginBackgroundUrl(cacheBust(response.data.url || ''));

    } catch (error) {

      console.error('Erro ao carregar background:', error);

    }

  };



  const handleUploadLoginBackground = async (event) => {

    const file = event.target.files[0];

    if (!file) return;



    const formData = new FormData();

    formData.append('file', file);



    setUploadingBackground(true);

    try {

      const response = await api.post('/branding/login-background', formData, {

        headers: { 'Content-Type': 'multipart/form-data' },

      });

      setLoginBackgroundUrl(cacheBust(response.data.url || ''));

      toast.success('Background atualizado com sucesso!');

    } catch (error) {

      console.error('Erro ao enviar background:', error);

      toast.error(error.response.data.error || 'Erro ao enviar background');

    } finally {

      setUploadingBackground(false);

      event.target.value = '';

    }

  };



  const loadPapelTimbrado = async () => {

    try {

      const response = await api.get('/documentos/papel-timbrado');

      setPapelTimbradoUrl(cacheBust(response.data.url || ''));

    } catch (error) {

      console.error('Erro ao carregar papel timbrado:', error);

    }

  };



  const loadMapaDanos = async () => {

    try {

      const response = await api.get('/branding/avaliacao-mapa');

      setMapaDanosUrl(cacheBust(response.data.url || ''));

    } catch (error) {

      console.error('Erro ao carregar mapa de danos:', error);

    }

  };



  const handleUploadMapaDanos = async (event) => {

    const file = event.target.files[0];

    if (!file) return;



    const formData = new FormData();

    formData.append('file', file);



    setUploadingMapaDanos(true);

    try {

      const response = await api.post('/branding/avaliacao-mapa', formData, {

        headers: { 'Content-Type': 'multipart/form-data' },

      });

      setMapaDanosUrl(cacheBust(response.data.url || ''));

      toast.success('Mapa de danos atualizado com sucesso!');

    } catch (error) {

      console.error('Erro ao enviar mapa de danos:', error);

      toast.error(error.response.data.error || 'Erro ao enviar mapa de danos');

    } finally {

      setUploadingMapaDanos(false);

      event.target.value = '';

    }

  };



  const handleUploadPapelTimbrado = async (event) => {

    const file = event.target.files[0];

    if (!file) return;



    const formData = new FormData();

    formData.append('file', file);



    setUploadingTimbrado(true);

    try {

      const response = await api.post('/documentos/papel-timbrado', formData, {

        headers: { 'Content-Type': 'multipart/form-data' },

      });

      setPapelTimbradoUrl(cacheBust(response.data.url || ''));

      toast.success('Papel timbrado atualizado com sucesso!');

    } catch (error) {

      console.error('Erro ao enviar papel timbrado:', error);

      toast.error(error.response.data.error || 'Erro ao enviar papel timbrado');

    } finally {

      setUploadingTimbrado(false);

      event.target.value = '';

    }

  };



  // ==================== ABA BACKUP ====================

  const loadAgendamento = async () => {
    try {
      const response = await api.get('/backup/agendamento');
      setBackupFrequencia(response.data?.frequencia || 'desativado');
    } catch (error) {
      console.error('Erro ao carregar agendamento:', error);
    }
  };

  const handleSalvarAgendamento = async () => {
    setLoadingAgendamento(true);
    try {
      await api.post('/backup/agendamento', { frequencia: backupFrequencia });
      toast.success('Agendamento salvo com sucesso!');
    } catch (error) {
      toast.error('Erro ao salvar agendamento');
    } finally {
      setLoadingAgendamento(false);
    }
  };

  const loadBackups = async () => {

    try {

      const response = await api.get('/backup/listar');

      const data = response.data?.backups || [];

      // Garantir que seja um array

      setBackups(Array.isArray(data) ? data : []);

    } catch (error) {

      console.error('Erro ao carregar backups:', error);

      // Não mostrar erro se endpoint não existir ainda

      setBackups([]);

    }

  };



  const handleExecutarBackup = async () => {

    if (loadingBackup) return;



    setLoadingBackup(true);

    try {

      const response = await api.post('/backup/executar');

      toast.success('Backup criado! Download iniciando...');

      loadBackups();

      if (response.data?.arquivo) {
        setTimeout(() => {
          window.open(`/api/backup/download/${encodeURIComponent(response.data.arquivo)}`, '_blank');
        }, 500);
      }

    } catch (error) {

      console.error('Erro ao executar backup:', error);

      toast.error(error?.response?.data?.error || 'Erro ao executar backup');

    } finally {

      setLoadingBackup(false);

    }

  };



  const handleDownloadBackup = async (arquivo) => {
    if (!arquivo) return;
    try {
      const response = await api.get(`/backup/download/${encodeURIComponent(arquivo)}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', arquivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('Erro ao baixar backup');
    }
  };

  const handleDeleteBackup = async (arquivo) => {
    if (!window.confirm(`Excluir o backup "${arquivo}"? Esta ação não pode ser desfeita.`)) return;
    try {
      await api.delete(`/backup/excluir/${encodeURIComponent(arquivo)}`);
      toast.success('Backup excluído com sucesso!');
      setBackups((prev) => prev.filter((b) => b.nome !== arquivo));
    } catch (error) {
      toast.error('Erro ao excluir backup');
    }
  };



  const handleRestaurarBackup = async (backupArquivo) => {

    if (

      !window.confirm(

        'Tem certeza que deseja restaurar este backup? Todos os dados atuais serão substituídos.'

      )

    ) {

      return;

    }



    try {

      await api.post(`/backup/restaurar/${encodeURIComponent(backupArquivo)}`);

      toast.success('Backup restaurado com sucesso!');

      window.location.reload(); // Recarregar aplicação

    } catch (error) {

      console.error('Erro ao restaurar backup:', error);

      const detalhe = error?.response?.data?.detalhe;
      toast.error((error?.response?.data?.error || 'Erro ao restaurar backup') + (detalhe ? `: ${detalhe}` : ''));

    }

  };



  // ==================== ABA OUTORGADOS ====================

  const loadOutorgados = async () => {
    try {
      const response = await api.get('/configuracoes/outorgados');
      setOutorgados(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      toast.error('Erro ao carregar outorgados');
    }
  };

  const saveOutorgados = async (lista) => {
    try {
      await api.post('/configuracoes/outorgados', lista);
      setOutorgados(lista);
      toast.success('Outorgados salvos com sucesso!');
    } catch (error) {
      toast.error('Erro ao salvar outorgados');
    }
  };

  const handleToggleOutorgado = (id) => {
    const nova = outorgados.map((o) => o.id === id ? { ...o, ativo: !o.ativo } : o);
    saveOutorgados(nova);
  };

  const handleOpenOutorgado = (outorgado = null) => {
    if (outorgado) {
      setEditingOutorgadoId(outorgado.id);
      setOutorgadoForm({
        nome: outorgado.nome || '',
        cpf: outorgado.cpf || '',
        rg: outorgado.rg || '',
        nacionalidade: outorgado.nacionalidade || 'BRASILEIRA',
        endereco: outorgado.endereco || '',
        numero: outorgado.numero || '',
        complemento: outorgado.complemento || '',
        bairro: outorgado.bairro || '',
        cidade: outorgado.cidade || '',
        estado: outorgado.estado || '',
      });
    } else {
      setEditingOutorgadoId(null);
      setOutorgadoForm({ nome: '', cpf: '', rg: '', nacionalidade: 'BRASILEIRA', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '' });
    }
    setOpenOutorgado(true);
  };

  const handleSubmitOutorgado = () => {
    if (!outorgadoForm.nome.trim()) { toast.error('Informe o nome'); return; }
    let nova;
    if (editingOutorgadoId) {
      nova = outorgados.map((o) => o.id === editingOutorgadoId ? { ...o, ...outorgadoForm } : o);
    } else {
      const novoId = `pessoa_${Date.now()}`;
      nova = [...outorgados, { id: novoId, tipo: 'pessoa', ativo: true, ...outorgadoForm }];
    }
    saveOutorgados(nova);
    setOpenOutorgado(false);
  };

  const handleDeleteOutorgado = (id) => {
    if (!window.confirm('Remover este outorgado?')) return;
    saveOutorgados(outorgados.filter((o) => o.id !== id));
  };

  return (

    <Box>

      <Typography variant="h4" gutterBottom>

        Configurações

      </Typography>



      <Paper>

        <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)}>

          <Tab label="Usuários" />

          <Tab label="Banco de Dados" />

          <Tab label="Dados da Empresa" />

          <Tab label="Aparência" />

          <Tab label="Backup" />

          <Tab label="Papel Timbrado" />

          <Tab label="Outorgados" />

        </Tabs>



        {/* ==================== TAB PANEL 0: USUÁRIOS ==================== */}

        <TabPanel value={tab} index={0}>

          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography variant="h6">Gerenciamento de Usuários</Typography>

            <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenUsuario()}>

              Novo Usuário

            </Button>

          </Box>



          <TableContainer>

            <Table>

              <TableHead>

                <TableRow>

                  <TableCell>Nome</TableCell>

                  <TableCell>Login</TableCell>

                  <TableCell>Nível de Acesso</TableCell>

                  <TableCell>Status</TableCell>

                  <TableCell align="right">Aões</TableCell>

                </TableRow>

              </TableHead>

              <TableBody>

                {usuarios.length === 0 ? (

                  <TableRow>

                    <TableCell colSpan={5} align="center">

                      <Typography variant="body2" color="textSecondary">

                        Nenhum usuário cadastrado

                      </Typography>

                    </TableCell>

                  </TableRow>

                ) : (

                  usuarios.map((usuario) => (

                    <TableRow key={usuario.id}>

                      <TableCell>{usuario.nome}</TableCell>

                      <TableCell>{usuario.email}</TableCell>

                      <TableCell>

                        <Chip

                          label={getNivelAcessoLabel(usuario.nivel_acesso)}

                          color={getNivelAcessoColor(usuario.nivel_acesso)}

                          size="small"

                        />

                      </TableCell>

                      <TableCell>

                        <Chip

                          label={usuario.ativo ? 'Ativo' : 'Inativo'}

                          color={usuario.ativo ? 'success' : 'default'}

                          size="small"

                        />

                      </TableCell>

                      <TableCell align="right">

                        <IconButton

                          size="small"

                          color="primary"

                          onClick={() => handleOpenUsuario(usuario)}

                          title="Editar"

                        >

                          <EditIcon />

                        </IconButton>

                        <IconButton

                          size="small"

                          color={usuario.ativo ? 'warning' : 'success'}

                          onClick={() => handleToggleUsuarioAtivo(usuario.id, usuario.ativo)}

                          title={usuario.ativo ? 'Desativar' : 'Ativar'}

                        >

                          <RefreshIcon />

                        </IconButton>

                      </TableCell>

                    </TableRow>

                  ))

                )}

              </TableBody>

            </Table>

          </TableContainer>



          <Box sx={{ mt: 3 }}>

            <Alert severity="info">

              <strong>Níveis de Acesso:</strong>

              <br />

               <strong>Administrador:</strong> Acesso total ao sistema

              <br />

               <strong>Gerente:</strong> Acesso a vendas, relatórios e cadastros

              <br />

               <strong>Vendedor:</strong> Acesso a vendas e consultas

              <br /> <strong>Operador:</strong> Acesso limitado a cadastros básicos

            </Alert>

          </Box>

        </TabPanel>



        {/* ==================== TAB PANEL 1: BANCO DE DADOS ==================== */}

        <TabPanel value={tab} index={1}>

          <Typography variant="h6" gutterBottom>

            Configurações de Banco de Dados

          </Typography>



          <Alert severity="info" sx={{ mb: 3 }}>

            O sistema está utilizando <strong>SQLite</strong> como banco de dados local.

            <br />

            Arquivo do banco: <code>backend/database/basecomm.db</code>

          </Alert>



          <Grid container spacing={2}>

            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 2 }}>

                <Typography variant="subtitle1" gutterBottom>

                  <strong>Informaões do Banco</strong>

                </Typography>

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2" sx={{ mb: 1 }}>

                  <strong>Tipo:</strong> SQLite

                </Typography>

                <Typography variant="body2" sx={{ mb: 1 }}>

                  <strong>Localização:</strong> ./database/basecomm.db

                </Typography>

                <Typography variant="body2" sx={{ mb: 1 }}>

                  <strong>Status:</strong> <Chip label="Conectado" color="success" size="small" />

                </Typography>

              </Paper>

            </Grid>



            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 2 }}>

                <Typography variant="subtitle1" gutterBottom>

                  <strong>Opões Avanadas</strong>

                </Typography>

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>

                  Para alterar configurações avançadas do banco de dados, edite o arquivo{' '}

                  <code>.env</code> no diretório do backend.

                </Typography>

                <Button variant="outlined" disabled>

                  Testar Conexão

                </Button>

              </Paper>

            </Grid>

          </Grid>



          <Box sx={{ mt: 3 }}>

            <Alert severity="warning">

              <strong>Atenção:</strong> Alterações nas configurações de banco de dados podem causar

              perda de dados. Sempre faça backup antes de modificar essas configurações.

            </Alert>

          </Box>

        </TabPanel>



        {/* ==================== TAB PANEL 2: DADOS DA EMPRESA ==================== */}

        <TabPanel value={tab} index={2}>

          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography variant="h6">Dados da Empresa</Typography>

            <Button

              variant="contained"

              startIcon={<SaveIcon />}

              onClick={handleSalvarEmpresa}

              disabled={loadingEmpresa}

            >

              {loadingEmpresa ? 'Salvando...' : 'Salvar Alterações'}

            </Button>

          </Box>



          <Alert severity="info" sx={{ mb: 3 }}>

            Estes dados serão utilizados automaticamente nos documentos gerados pelo sistema (Procuraões, Contratos, etc.).

          </Alert>



          <Paper variant="outlined" sx={{ p: 3 }}>

            <Grid container spacing={3}>

              <Grid item xs={12}>

                <TextField

                  fullWidth

                  required

                  label="Razão Social"

                  value={empresaData.razao_social}

                  onChange={(e) => setEmpresaData({ ...empresaData, razao_social: e.target.value })}

                  placeholder="Nome completo da empresa"

                />

              </Grid>



              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  label="CNPJ"

                  value={empresaData.cnpj}

                  onChange={(e) => setEmpresaData({ ...empresaData, cnpj: e.target.value })}

                  placeholder="00.000.000/0000-00"

                />

              </Grid>



              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  label="CEP"

                  value={empresaData.cep}

                  onChange={(e) => setEmpresaData({ ...empresaData, cep: e.target.value })}

                  placeholder="00000-000"

                />

              </Grid>



              <Grid item xs={12}>

                <TextField

                  fullWidth

                  label="Endereço Completo"

                  value={empresaData.endereco}

                  onChange={(e) => setEmpresaData({ ...empresaData, endereco: e.target.value })}

                  placeholder="Rua, Nmero, Complemento, Bairro"

                />

              </Grid>



              <Grid item xs={12} sm={8}>

                <TextField

                  fullWidth

                  label="Cidade"

                  value={empresaData.cidade}

                  onChange={(e) => setEmpresaData({ ...empresaData, cidade: e.target.value })}

                  placeholder="Nome da cidade"

                />

              </Grid>



              <Grid item xs={12} sm={4}>

                <TextField

                  fullWidth

                  label="Estado (UF)"

                  value={empresaData.estado}

                  onChange={(e) => setEmpresaData({ ...empresaData, estado: e.target.value.toUpperCase() })}

                  placeholder="SP"

                  inputProps={{ maxLength: 2 }}

                />

              </Grid>



              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  label="Telefone"

                  value={empresaData.telefone}

                  onChange={(e) => setEmpresaData({ ...empresaData, telefone: e.target.value })}

                  placeholder="(00) 00000-0000"

                />

              </Grid>



              <Grid item xs={12} sm={6}>

                <TextField

                  fullWidth

                  label="Email"

                  type="email"

                  value={empresaData.email}

                  onChange={(e) => setEmpresaData({ ...empresaData, email: e.target.value })}

                  placeholder="contato@empresa.com"

                />

              </Grid>

            </Grid>

          </Paper>



          <Box sx={{ mt: 3 }}>

            <Alert severity="warning">

              <strong>Importante:</strong> Certifique-se de que todos os dados estejam corretos antes de salvar.

              Estes dados aparecero em todos os documentos oficiais gerados pelo sistema.

            </Alert>

          </Box>

        </TabPanel>



        {/* ==================== TAB PANEL 3: APARÊNCIA ==================== */}

        <TabPanel value={tab} index={3}>

          <Typography variant="h6" gutterBottom>

            Background da tela de login

          </Typography>



          <Alert severity="info" sx={{ mb: 3 }}>

            Envie uma imagem para personalizar o fundo da tela de login.

          </Alert>



          <Grid container spacing={3}>

            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 3 }}>

                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>

                  Upload do background

                </Typography>

                <Divider sx={{ my: 2 }} />



                <Box sx={{ mb: 2 }}>

                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>

                    <strong>Requisitos da imagem:</strong>

                  </Typography>

                  <List dense>

                    <ListItem>

                      <ListItemText primary="- Formato: PNG ou JPG" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Proporção recomendada: 16:9" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Tamanho máximo: 5 MB" />

                    </ListItem>

                  </List>

                </Box>



                <input

                  accept="image/png,image/jpeg"

                  style={{ display: 'none' }}

                  id="upload-login-background"

                  type="file"

                  onChange={handleUploadLoginBackground}

                />

                <label htmlFor="upload-login-background">

                  <Button variant="contained" component="span" fullWidth disabled={uploadingBackground}>

                    {uploadingBackground ? 'Enviando...' : 'Selecionar imagem'}

                  </Button>

                </label>

              </Paper>

            </Grid>



            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 3 }}>

                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>

                  Preview atual

                </Typography>

                <Divider sx={{ my: 2 }} />



                <Box

                  sx={{

                    border: '1px dashed rgba(255,255,255,0.2)',

                    borderRadius: 2,

                    minHeight: 220,

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    backgroundColor: 'rgba(255,255,255,0.04)',

                    backgroundImage: loginBackgroundUrl ? `url(${loginBackgroundUrl})` : 'none',

                    backgroundSize: 'cover',

                    backgroundPosition: 'center',

                    color: loginBackgroundUrl ? 'transparent' : 'text.secondary',

                  }}

                >

                  {!loginBackgroundUrl && (

                    <Typography variant="body2" color="textSecondary">

                      Nenhuma imagem configurada

                    </Typography>

                  )}

                </Box>

              </Paper>

            </Grid>

          </Grid>



          <Divider sx={{ my: 4 }} />



          <Typography variant="h6" gutterBottom>

            Mapa de danos da avaliação

          </Typography>



          <Alert severity="info" sx={{ mb: 3 }}>

            Envie a imagem base do veículo para marcar os danos durante a avaliação.

          </Alert>



          <Grid container spacing={3}>

            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 3 }}>

                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>

                  Upload do mapa

                </Typography>

                <Divider sx={{ my: 2 }} />



                <Box sx={{ mb: 2 }}>

                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>

                    <strong>Requisitos da imagem:</strong>

                  </Typography>

                  <List dense>

                    <ListItem>

                      <ListItemText primary="- Formato: PNG ou JPG" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Fundo claro e boa legibilidade" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Tamanho máximo: 5 MB" />

                    </ListItem>

                  </List>

                </Box>



                <input

                  accept="image/png,image/jpeg"

                  style={{ display: 'none' }}

                  id="upload-avaliacao-mapa"

                  type="file"

                  onChange={handleUploadMapaDanos}

                />

                <label htmlFor="upload-avaliacao-mapa">

                  <Button variant="contained" component="span" fullWidth disabled={uploadingMapaDanos}>

                    {uploadingMapaDanos ? 'Enviando...' : 'Selecionar imagem'}

                  </Button>

                </label>

              </Paper>

            </Grid>



            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 3 }}>

                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>

                  Preview atual

                </Typography>

                <Divider sx={{ my: 2 }} />



                <Box

                  sx={{

                    border: '1px dashed rgba(255,255,255,0.2)',

                    borderRadius: 2,

                    minHeight: 220,

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    backgroundColor: 'rgba(255,255,255,0.04)',

                    backgroundImage: mapaDanosUrl ? `url(${mapaDanosUrl})` : 'none',

                    backgroundSize: 'contain',

                    backgroundRepeat: 'no-repeat',

                    backgroundPosition: 'center',

                    color: mapaDanosUrl ? 'transparent' : 'text.secondary',

                  }}

                >

                  {!mapaDanosUrl && (

                    <Typography variant="body2" color="textSecondary">

                      Nenhuma imagem configurada

                    </Typography>

                  )}

                </Box>

              </Paper>

            </Grid>

          </Grid>

        </TabPanel>



        {/* ==================== TAB PANEL 4: BACKUP ==================== */}

        <TabPanel value={tab} index={4}>

          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography variant="h6">Sistema de Backup</Typography>

            <Button

              variant="contained"

              startIcon={<BackupIcon />}

              onClick={handleExecutarBackup}

              disabled={loadingBackup}

            >

              {loadingBackup ? 'Executando...' : 'Executar Backup Agora'}

            </Button>

          </Box>



          <Alert severity="info" sx={{ mb: 3 }}>

            Os backups são salvos no diretório <code>backend/backups/</code>

          </Alert>



          <Grid container spacing={3}>

            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 2 }}>

                <Typography variant="subtitle1" gutterBottom>

                  <strong>Backup Manual</strong>

                </Typography>

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>

                  Clique no botão "Executar Backup Agora" para criar um backup manual do banco de

                  dados.

                </Typography>

                <Typography variant="body2" color="textSecondary">

                  O backup incluirá:

                </Typography>

                <List dense>

                  <ListItem>

                    <ListItemText primary="- Banco de dados completo (SQLite)" />

                  </ListItem>

                  <ListItem>

                    <ListItemText primary="- Arquivos enviados (uploads)" />

                  </ListItem>

                  <ListItem>

                    <ListItemText primary="- Configurações do sistema" />

                  </ListItem>

                </List>

              </Paper>

            </Grid>



            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 2 }}>

                <Typography variant="subtitle1" gutterBottom>

                  <strong>Backup Automático</strong>

                </Typography>

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>

                  Configure o agendamento de backups automáticos:

                </Typography>

                <TextField

                  select

                  fullWidth

                  label="Frequência"

                  value={backupFrequencia}

                  onChange={(e) => setBackupFrequencia(e.target.value)}

                  size="small"

                  sx={{ mb: 2 }}

                >

                  <MenuItem value="desativado">Desativado</MenuItem>

                  <MenuItem value="hora">A cada hora</MenuItem>

                  <MenuItem value="diario">Diário (02:00)</MenuItem>

                  <MenuItem value="semanal">Semanal (domingo 02:00)</MenuItem>

                  <MenuItem value="mensal">Mensal (dia 1 às 02:00)</MenuItem>

                </TextField>

                <Button variant="outlined" startIcon={<SaveIcon />} fullWidth onClick={handleSalvarAgendamento} disabled={loadingAgendamento}>

                  {loadingAgendamento ? 'Salvando...' : 'Salvar Configurações'}

                </Button>

              </Paper>

            </Grid>

          </Grid>



          <Box sx={{ mt: 3 }}>

            <Typography variant="h6" gutterBottom>

              Backups Disponíveis

            </Typography>



            {backups.length === 0 ? (

              <Paper variant="outlined" sx={{ p: 3, textAlign: 'center' }}>

                <Typography variant="body2" color="textSecondary">

                  Nenhum backup encontrado

                </Typography>

              </Paper>

            ) : (

              <TableContainer component={Paper} variant="outlined">

                <Table>

                  <TableHead>

                    <TableRow>

                      <TableCell>Data/Hora</TableCell>

                      <TableCell>Tamanho</TableCell>

                      <TableCell>Tipo</TableCell>

                      <TableCell align="right">Aões</TableCell>

                    </TableRow>

                  </TableHead>

                  <TableBody>

                    {backups.map((backup) => (

                      <TableRow key={backup.id || backup.nome}>

                        <TableCell>

                          {new Date(backup.created_at || backup.data_criacao).toLocaleString('pt-BR')}

                        </TableCell>

                        <TableCell>{backup.tamanho || '-'}</TableCell>

                        <TableCell>

                          <Chip label={backup.tipo || 'Manual'} size="small" />

                        </TableCell>

                        <TableCell align="right">

                          <Button

                            size="small"

                            startIcon={<RestoreIcon />}

                            onClick={() => handleRestaurarBackup(backup.nome)}

                            sx={{ mr: 1 }}

                          >

                            Restaurar

                          </Button>

                          <Button

                            size="small"

                            onClick={() => handleDownloadBackup(backup.nome)}

                            sx={{ mr: 1 }}

                          >

                            Baixar

                          </Button>

                          <Button

                            size="small"

                            color="error"

                            startIcon={<DeleteIcon />}

                            onClick={() => handleDeleteBackup(backup.nome)}

                          >

                            Excluir

                          </Button>

                        </TableCell>

                      </TableRow>

                    ))}

                  </TableBody>

                </Table>

              </TableContainer>

            )}

          </Box>



          <Box sx={{ mt: 3 }}>

            <Alert severity="warning">

              <strong>Atenção:</strong> Ao restaurar um backup, todos os dados atuais serão

              substituídos pelos dados do backup selecionado. Esta ação não pode ser desfeita.

            </Alert>

          </Box>

        </TabPanel>



        {/* ==================== TAB PANEL 5: PAPEL TIMBRADO ==================== */}

        <TabPanel value={tab} index={5}>

          <Typography variant="h6" gutterBottom>

            Papel Timbrado para Documentos

          </Typography>



          <Alert severity="info" sx={{ mb: 3 }}>

            Envie uma imagem (PNG ou JPG) do papel timbrado da sua empresa no formato A4.

            <br />

            Esta imagem será usada como fundo em todos os documentos gerados pelo sistema.

          </Alert>



          <Grid container spacing={3}>

            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 3 }}>

                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>

                  Upload de Papel Timbrado

                </Typography>

                <Divider sx={{ my: 2 }} />



                <Box sx={{ mb: 2 }}>

                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>

                    <strong>Requisitos da imagem:</strong>

                  </Typography>

                  <List dense>

                    <ListItem>

                      <ListItemText primary="- Formato: PNG ou JPG" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Tamanho: A4 (210mm x 297mm)" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Resolução recomendada: 300 DPI" />

                    </ListItem>

                    <ListItem>

                      <ListItemText primary="- Tamanho máximo: 5 MB" />

                    </ListItem>

                  </List>

                </Box>



                <input

                  accept="image/png,image/jpeg"

                  style={{ display: 'none' }}

                  id="upload-papel-timbrado"

                  type="file"

                  onChange={handleUploadPapelTimbrado}

                />

                <label htmlFor="upload-papel-timbrado">

                  <Button variant="contained" component="span" fullWidth disabled={uploadingTimbrado}>

                    {uploadingTimbrado ? 'Enviando...' : 'Selecionar Arquivo'}

                  </Button>

                </label>



                <Typography variant="caption" color="textSecondary" sx={{ mt: 2, display: 'block' }}>

                  Formatos suportados: PNG ou JPG

                </Typography>

              </Paper>

            </Grid>



            <Grid item xs={12} md={6}>

              <Paper variant="outlined" sx={{ p: 3 }}>

                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>

                  Papel Timbrado Atual

                </Typography>

                <Divider sx={{ my: 2 }} />



                <Box

                  sx={{

                    border: '1px dashed rgba(255,255,255,0.2)',

                    borderRadius: 1,

                    p: 3,

                    textAlign: 'center',

                    minHeight: 200,

                    display: 'flex',

                    alignItems: 'center',

                    justifyContent: 'center',

                    backgroundColor: 'rgba(255,255,255,0.04)',

                    backgroundImage: papelTimbradoUrl ? `url(${papelTimbradoUrl})` : 'none',

                    backgroundSize: 'cover',

                    backgroundPosition: 'center',

                  }}

                >

                  {!papelTimbradoUrl && (

                    <Typography variant="body2" color="textSecondary">

                      Nenhum papel timbrado configurado

                    </Typography>

                  )}

                </Box>



                <Box sx={{ mt: 2 }}>

                  <Button

                    variant="outlined"

                    fullWidth

                    disabled={!papelTimbradoUrl}

                    onClick={() => papelTimbradoUrl && window.open(papelTimbradoUrl, '_blank')}

                  >

                    Visualizar em Tamanho Real

                  </Button>

                </Box>

              </Paper>

            </Grid>

          </Grid>



          <Box sx={{ mt: 3 }}>

            <Alert severity="warning">

              <strong>Atenção:</strong> O papel timbrado será aplicado automaticamente em todos os

              documentos gerados (Contratos, Procuraões, Recibos). Certifique-se de que a imagem

              esteja correta antes de enviar.

            </Alert>

          </Box>



          <Box sx={{ mt: 3 }}>

            <Paper variant="outlined" sx={{ p: 2 }}>

              <Typography variant="subtitle2" gutterBottom>

                <strong>Dicas para melhor resultado:</strong>

              </Typography>

              <Typography variant="body2" color="textSecondary">

                1. Use uma imagem clara com boa qualidade

                <br />

                2. Deixe margens suficientes para o texto (recomendado: 2cm em todos os lados)

                <br />

                3. Evite fundos muito escuros que dificultem a leitura

                <br />

                4. Inclua logo e informaões da empresa no cabeçalho/rodapé

                <br />

                5. Teste com um documento antes de usar oficialmente

              </Typography>

            </Paper>

          </Box>

        </TabPanel>

        {/* ==================== TAB PANEL 6: OUTORGADOS ==================== */}
        <TabPanel value={tab} index={6}>
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Outorgados para Procuração</Typography>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpenOutorgado()}>
              Adicionar Pessoa
            </Button>
          </Box>

          <Alert severity="info" sx={{ mb: 3 }}>
            Configure quem pode ser o <strong>Outorgado</strong> nas procurações. A empresa (cadastrada em Dados da Empresa) está sempre disponível. Adicione pessoas físicas conforme necessário. Use o toggle para ativar/desativar cada opção.
          </Alert>

          <List>
            {outorgados.map((o) => (
              <React.Fragment key={o.id}>
                <ListItem>
                  <Box sx={{ mr: 2, color: 'primary.main' }}>
                    {o.tipo === 'empresa' ? <BusinessIcon /> : <PersonIcon />}
                  </Box>
                  <ListItemText
                    primary={o.tipo === 'empresa' ? 'Empresa (dados de Configurações)' : o.nome}
                    secondary={o.tipo === 'pessoa' ? `CPF: ${o.cpf || '-'} | ${o.cidade || ''}${o.estado ? `/${o.estado}` : ''}` : 'Razão social e CNPJ conforme cadastro da empresa'}
                  />
                  <ListItemSecondaryAction sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FormControlLabel
                      control={<Switch checked={!!o.ativo} onChange={() => handleToggleOutorgado(o.id)} />}
                      label={o.ativo ? 'Ativo' : 'Inativo'}
                      labelPlacement="start"
                    />
                    {o.tipo === 'pessoa' && (
                      <>
                        <IconButton size="small" onClick={() => handleOpenOutorgado(o)}><EditIcon fontSize="small" /></IconButton>
                        <IconButton size="small" color="error" onClick={() => handleDeleteOutorgado(o.id)}><DeleteIcon fontSize="small" /></IconButton>
                      </>
                    )}
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
            {outorgados.length === 0 && (
              <ListItem><ListItemText primary="Nenhum outorgado configurado. Acesse e salve uma vez para carregar a empresa padrão." /></ListItem>
            )}
          </List>
        </TabPanel>

      </Paper>



      {/* Dialog - Novo/Editar Usuário */}

      <Dialog open={openUsuario} onClose={handleCloseUsuario} maxWidth="sm" fullWidth>

        <DialogTitle>{editingUsuarioId ? 'Editar Usuário' : 'Novo Usuário'}</DialogTitle>

        <DialogContent>

          <Grid container spacing={2} sx={{ mt: 1 }}>

            <Grid item xs={12}>

              <TextField

                fullWidth

                required

                label="Nome Completo"

                placeholder="Ex: Anderson Silva"

                value={usuarioFormData.nome}

                onChange={(e) => setUsuarioFormData({ ...usuarioFormData, nome: e.target.value })}

                helperText="O login ser gerado automaticamente: nome.sobrenome"

              />

            </Grid>



            <Grid item xs={12}>

              <TextField

                fullWidth

                disabled={editingUsuarioId ? true : false}

                label={editingUsuarioId ? "Login (nome.sobrenome)" : "Login (deixe vazio para gerar automaticamente)"}

                placeholder="anderson.silva"

                value={usuarioFormData.email}

                onChange={(e) => setUsuarioFormData({ ...usuarioFormData, email: e.target.value.toLowerCase() })}

                helperText={editingUsuarioId ? "Login não pode ser alterado" : "Gerado automaticamente a partir do nome"}

              />

            </Grid>



            <Grid item xs={12}>

              <TextField

                fullWidth

                label={editingUsuarioId ? 'Nova Senha (deixe vazio para manter)' : 'Senha'}

                type="password"

                required={!editingUsuarioId}

                value={usuarioFormData.senha}

                onChange={(e) => setUsuarioFormData({ ...usuarioFormData, senha: e.target.value })}

              />

            </Grid>



            <Grid item xs={12}>

              <TextField

                fullWidth

                select

                required

                label="Nível de Acesso"

                value={usuarioFormData.nivel_acesso}

                onChange={(e) =>

                  setUsuarioFormData({ ...usuarioFormData, nivel_acesso: e.target.value })

                }

              >

                <MenuItem value="admin">Administrador</MenuItem>

                <MenuItem value="gerente">Gerente</MenuItem>

                <MenuItem value="vendedor">Vendedor</MenuItem>

                <MenuItem value="operador">Operador</MenuItem>

              </TextField>

            </Grid>

          </Grid>

        </DialogContent>

        <DialogActions>

          <Button onClick={handleCloseUsuario}>Cancelar</Button>

          <Button onClick={handleSubmitUsuario} variant="contained">

            {editingUsuarioId ? 'Atualizar' : 'Criar Usuário'}

          </Button>

        </DialogActions>

      </Dialog>

      {/* Dialog - Novo/Editar Outorgado */}
      <Dialog open={openOutorgado} onClose={() => setOpenOutorgado(false)} maxWidth="md" fullWidth>
        <DialogTitle>{editingOutorgadoId ? 'Editar Outorgado' : 'Novo Outorgado (Pessoa Física)'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth required label="Nome Completo" value={outorgadoForm.nome} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, nome: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Nacionalidade" value={outorgadoForm.nacionalidade} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, nacionalidade: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="CPF" value={outorgadoForm.cpf} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, cpf: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="RG" value={outorgadoForm.rg} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, rg: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Número" value={outorgadoForm.numero} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, numero: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField fullWidth label="Endereço" value={outorgadoForm.endereco} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, endereco: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Complemento" value={outorgadoForm.complemento} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, complemento: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField fullWidth label="Bairro" value={outorgadoForm.bairro} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, bairro: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField fullWidth label="Cidade" value={outorgadoForm.cidade} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, cidade: e.target.value })} />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField fullWidth label="Estado (UF)" value={outorgadoForm.estado} onChange={(e) => setOutorgadoForm({ ...outorgadoForm, estado: e.target.value.toUpperCase() })} inputProps={{ maxLength: 2 }} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenOutorgado(false)}>Cancelar</Button>
          <Button onClick={handleSubmitOutorgado} variant="contained">
            {editingOutorgadoId ? 'Salvar' : 'Adicionar'}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>

  );

}





